module.exports = {
    install(Vue) {
        String.prototype.replaceAll = function(source, target) {
            source = source.replace(new RegExp("(\\W)", "g"), "\\$1");
            target = target.replace(new RegExp("\\$", "g"), "$$$$");
            return this.replace(new RegExp(source, "gm"), target);
        };

        Vue.prototype.$onbiLib = new Vue({
            data: {
                hostnames : {},
                msg:{
                    err:{
                        system:"통신상태가 원활하지 않습니다. 새로고침이 필요합니다."
                    },
                    suc:{
                        save:"저장 되었습니다.",
                        del:"삭제 되었습니다.",
                        up:"수정 되었습니다.",
                        reg:"등록 되었습니다.",
                        add:"추가 되었습니다.",
                        comp:"완료 되었습니다.",
                        chng:"변경 되었습니다."

                    }
                },
                hourList : [
                    {hour : '00', cd : '00'},
                    {hour : '01', cd : '01'},
                    {hour : '02', cd : '02'},
                    {hour : '03', cd : '03'},
                    {hour : '04', cd : '04'},
                    {hour : '05', cd : '05'},
                    {hour : '06', cd : '06'},
                    {hour : '07', cd : '07'},
                    {hour : '08', cd : '08'},
                    {hour : '09', cd : '09'},
                    {hour : '10', cd : '10'},
                    {hour : '11', cd : '11'},
                    {hour : '12', cd : '12'},
                    {hour : '13', cd : '13'},
                    {hour : '14', cd : '14'},
                    {hour : '15', cd : '15'},
                    {hour : '16', cd : '16'},
                    {hour : '17', cd : '17'},
                    {hour : '18', cd : '18'},
                    {hour : '19', cd : '19'},
                    {hour : '20', cd : '20'},
                    {hour : '21', cd : '21'},
                    {hour : '22', cd : '22'},
                    {hour : '23', cd : '23'},
                ],
                minuteList : [
                    {minute : '00', cd : '00'},
                    {minute : '05', cd : '05'},
                    {minute : '10', cd : '10'},
                    {minute : '15', cd : '15'},
                    {minute : '20', cd : '20'},
                    {minute : '25', cd : '25'},
                    {minute : '30', cd : '30'},
                    {minute : '35', cd : '35'},
                    {minute : '40', cd : '40'},
                    {minute : '45', cd : '45'},
                    {minute : '50', cd : '50'},
                    {minute : '55', cd : '55'},
                ],
                scrollOps: {
                    vuescroll: {
                        mode: 'native',
                        sizeStrategy: 'percent',
                        detectResize: true
                    },
                    scrollPanel: {
                        initialScrollY: false,
                        initialScrollX: false,
                        scrollingX: true,
                        scrollingY: true,
                        speed: 300,
                        easing: undefined,
                        verticalNativeBarPos: 'right'
                    },
                    rail: {
                        background: '#01a99a',
                        opacity: 0,
                        size: '6px',
                        specifyBorderRadius: false,
                        gutterOfEnds: null,
                        gutterOfSide: '2px',
                        keepShow: false
                    },
                    bar: {
                        showDelay: 500,
                        onlyShowBarOnScroll: true,
                        keepShow: false,
                        background: '#c1c1c1',
                        opacity: 1,
                        hoverStyle: false,
                        specifyBorderRadius: false,
                        minSize: 0,
                        size: '6px',
                        disable: false
                    }
                },
                cardCdList : [
                    {code : '01', cardNm : '하나(외환)'},
                    {code : '03', cardNm : '롯데'},
                    {code : '04', cardNm : '현대'},
                    {code : '06', cardNm : '국민'},
                    {code : '11', cardNm : 'BC'},
                    {code : '12', cardNm : '삼성'},
                    {code : '14', cardNm : '신한'},
                    {code : '21', cardNm : '해외 VISA'},
                    {code : '22', cardNm : '해외마스터'},
                    {code : '23', cardNm : '해외 JCB'},
                    {code : '26', cardNm : '중국은련'},
                    {code : '32', cardNm : '광주'},
                    {code : '33', cardNm : '전북'},
                    {code : '34', cardNm : '하나'},
                    {code : '35', cardNm : '산업카드'},
                    {code : '41', cardNm : 'NH'},
                    {code : '43', cardNm : '씨티'},
                    {code : '44', cardNm : '우리'},
                    {code : '48', cardNm : '신협체크'},
                    {code : '51', cardNm : '수협'},
                    {code : '52', cardNm : '제주'},
                    {code : '54', cardNm : 'MG새마을금고체크'},
                    {code : '55', cardNm : '케이뱅크'},
                    {code : '56', cardNm : '카카오뱅크'},
                    {code : '71', cardNm : '우체국체크'},
                    {code : '95', cardNm : '저축은행체크'},
                ],
                cardBnkCdList : [
                    {code : '02', cardNm : '한국산업은행'},
                    {code : '03', cardNm : '기업은행'},
                    {code : '04', cardNm : '국민은행'},
                    {code : '05', cardNm : '하나은행 (구외환)'},
                    {code : '06', cardNm : '국민은행 (구 주택)'},
                    {code : '07', cardNm : '수협중앙회'},
                    {code : '11', cardNm : '농협중앙회'},
                    {code : '12', cardNm : '단위농협'},
                    {code : '16', cardNm : '축협중앙회'},
                    {code : '20', cardNm : '우리은행'},
                    {code : '21', cardNm : '신한은행 (조흥은행)'},
                    {code : '23', cardNm : '제일은행'},
                    {code : '25', cardNm : '하나은행 (서울은행)'},
                    {code : '26', cardNm : '신한은행'},
                    {code : '27', cardNm : '한국씨티은행 (한미은행)'},
                    {code : '31', cardNm : '대구은행'},
                    {code : '32', cardNm : '부산은행'},
                    {code : '34', cardNm : '광주은행'},
                    {code : '35', cardNm : '제주은행'},
                    {code : '37', cardNm : '전북은행'},
                    {code : '38', cardNm : '강원은행'},
                    {code : '39', cardNm : '경남은행'},
                    {code : '41', cardNm : '비씨카드'},
                    {code : '53', cardNm : '씨티은행'},
                    {code : '54', cardNm : '홍콩상하이은행'},
                    {code : '71', cardNm : '우체국'},
                    {code : '81', cardNm : '하나은행'},
                    {code : '83', cardNm : '평화은행'},
                    {code : '87', cardNm : '신세계'},
                    {code : '88', cardNm : '신한은행(조흥 통합)'},
                    {code : '97', cardNm : '카카오 머니'},
                    {code : '98', cardNm : '페이코 (포인트 100% 사용)'},
                ],
            },
            methods:{
                getCdnTransmisSn: function(){
                    const onbiLib = this;

                    return new Promise(function (resolve, reject) {
                        onbiLib.axios.get('/fileApi/getTransmisSn').then(function(response) {
                            resolve(response.data.transmisSn);
                        }.bind(this)).catch(function(e) {
                            reject(e);
                        });
                    });
                },
                searchDayTimeMs: function(){
                    const onbiLib = this;

                    return new Promise(function (resolve, reject) {
                        onbiLib.axios.post('/common/day/searchDayTimeMs.act',{}).then(function(response) {
                            resolve(response.data.dayTimeMs);
                        }.bind(this)).catch(function(e) {
                            reject(e);
                        });
                    });
                },
                saveCdnFileUploadInfo: function(uploadInfo){
                    const onbiLib = this;
                    return new Promise(function (resolve, reject) {

                        const resultCd = uploadInfo.resultCd;
                        const resultMsg = uploadInfo.resultMsg;

                        if(resultCd == '00'){
                            const fileList = uploadInfo.fileList;
                            fileList.forEach(function(info){
                                let extsn = info.extsn;
                                if(extsn == 'jpg'||extsn == 'mp4'){ info['sucAt'] = 'N';
                                }else{ info['sucAt'] = 'Y'; }
                            });
                            onbiLib.axios.post(
                                '/fileApi/saveFileUploadInfo',
                                {
                                    transmisSn: uploadInfo.transmisSn,
                                    resultCd: uploadInfo.resultCd,
                                    resultMsg: uploadInfo.resultMsg,
                                    fileList: fileList
                                }
                            ).then(function() {
                                fileList.forEach(function(info){
                                    info['fileSe'] = 'NEW';
                                    info['cdnAt'] = 'Y';
                                });
                                resolve(fileList);
                            }.bind(this)).catch(function(e) {
                                reject(e);
                            });
                        }else{
                            reject(resultMsg);
                        }



                        /*var resultCd = uploadInfo.resultCd;
                        var resultMsg = uploadInfo.resultMsg;
                        if(resultCd == '00'){
                            var fileList = uploadInfo.fileList;
                            var setFileList = new Array();
                            for(var i=0;i < fileList.length;i++){
                                var fileInfo = fileList[i];
                                var extsn = fileInfo.extsn;
                                if(extsn == 'jpg'||extsn == 'mp4'){ fileInfo['sucAt'] = 'N';
                                }else{ fileInfo['sucAt'] = 'Y'; }
                                setFileList.push(fileInfo);
                            }
                            axios.post(
                                '/fileApi/saveFileUploadInfo',
                                {
                                    transmisSn: uploadInfo.transmisSn,
                                    resultCd: uploadInfo.resultCd,
                                    resultMsg: uploadInfo.resultMsg,
                                    fileList: setFileList
                                }
                            ).then(function(response){
                                for(var i=0; i<setFileList.length; i++ ){
                                    var fileInfo = setFileList[i];
                                    fileInfo['fileSe'] = 'NEW';
                                    fileInfo['cdnAt'] = 'Y';
                                    fileCompnent.filelist.push(fileInfo);
                                }
                                resolve();
                            }).catch(function(e){
                                reject(e);
                            });
                        }else{
                            reject(resultMsg);
                        }*/

                    });
                },
                getImageFileUrl : function(fileSe,fileNm,storge,extsn,setBasePath){
                    let url = "/common/getImageFile.act?fileSe=" + fileSe + "&fileNm=" + fileNm + "&storge=" + storge + "&extsn=" + extsn;
                    if(typeof setBasePath != "undefined" && setBasePath != null){
                        if(setBasePath.trim() != ""){
                            url += "&setBasePath=" + setBasePath;
                        }
                    }

                    return url;
                },
                getImageFileCdUrl : function(fileCd, fcltcd){
                    let url = "/common/getImageFile.act?fileCd=" + fileCd+"&fcltcd="+fcltcd;
                    return url;
                },
                getVideoFileUrl : function(fileSe,fileNm,storge,extsn,setBasePath){
                    let url = "/common/getVideoFile.act?fileSe=" + fileSe + "&fileNm=" + fileNm + "&storge=" + storge + "&extsn=" + extsn;
                    if(typeof setBasePath != "undefined" && setBasePath != null){
                        if(setBasePath.trim() != ""){
                            url += "&setBasePath=" + setBasePath;
                        }
                    }

                    return url;
                },
                getMessageQueueInfo: function(queueName,message){
                    let host = '192.168.10.80';
                    let port = 5672;
                    let userName = 'mqadmin';
                    let password = 'mqadmin!';

                    if(location.host == "i5gam.gulumma.net"||location.host == "www.bo6in.com"||location.host == "i5gam.bo6in.com"){
                        host = '103.55.190.49';
                        userName = 'mqadmin';
                        password = 'mqadmin2020!';
                    }

                    const mqInfo = {
                        host:host,
                        port:port,
                        userName:userName,
                        password:password,
                        queueName:queueName,
                        message: message
                    }

                    return mqInfo;
                },
                getDocsConverterUrl : function(){
                    var url = '';
                    var host = location.host;
                    var protocol = location.protocol;
                    if(host == "i5gam.gulumma.net"||host == "www.bo6in.com"||host == "i5gam.bo6in.com"){
                        if(protocol.indexOf('https')>-1) url = protocol + '//hermes.gulumma.net';
                        else url = 'http://hermes.gulumma.net:8080';
                    }
                    url += '/hermes/convert.hs?';
                    return url;
                },
                getAuthKey:function(){
                    const onbiLib = this;

                    return new Promise(function (resolve, reject) {
                        onbiLib.axios.post('/common/getAuthKey').then(function(response) {
                            resolve(response.data.authKey);
                        }.bind(this)).catch(function(e) {
                            reject(e);
                        });
                    });

                },
                getCdnUrl: function(se){
                    var domain = "175.123.225.98";
                    var host = location.host;

                    if(host == "i5gam.gulumma.net"||host == "www.bo6in.com"||host == "i5gam.bo6in.com" || host== "adm.bo6in.com" || host == "i5gamadm.gulumma.net"){
                        if(se == 'U')  domain = "onandonup.qtcdn.co.kr";
                        else if(se == 'D')  domain = "onandonview.qtcdn.co.kr";
                    }

                    return location.protocol + '//' + domain;

                    /*if(se == 'U')  domain = "onandonup.qtcdn.co.kr";
                    else if(se == 'D')  domain = "onandonview.qtcdn.co.kr";

                    return 'https://' + domain;*/
                },
                chkCdnAt : function(fileInfo){
                    var cdnAt = false;
                    if(fileInfo.uploadSn != 'undefined'&&fileInfo.uploadSn != null){
                        if(fileInfo.uploadSn != '')cdnAt = true;
                    }

                    return cdnAt;
                },
                chkFileUploadFinish: function(fileInfo){
                    var finishAt = false;
                    if(this.chkCdnAt(fileInfo)){
                        if(fileInfo.transmisSe == 'R') finishAt = true;
                    }else{ finishAt = true; }
                    return finishAt;
                },
                getFileUrl : function(fileInfo,se,authKey){
                    /* se - T:'썸네일URL',I:'이미지뷰URL',S:'동영상스트리밍URL' */

                    var url = '';
                    if(this.chkCdnAt(fileInfo)){
                        var cdnUrl = this.getCdnUrl('D');
                        if(se == 'T') url = cdnUrl + fileInfo.thumbUrl + '?authKey=' + authKey;
                        else if(se == 'I') url = cdnUrl + fileInfo.imgViewUrl + '?authKey=' + authKey;
                        else if(se == 'S') url = cdnUrl + fileInfo.strmUrl + '?authKey=' + authKey;
                    }else{
                        url = this.getImageFileUrl(
                            fileInfo.fileSe,
                            fileInfo.fileNm,
                            fileInfo.storge,
                            fileInfo.extsn
                        );
                    }
                    return url;
                },
                getThumbnailUrl : function(fileInfo){
                    var url = this.getCdnUrl('D');
                    return url + fileInfo.thumbUrl;
                },
                showResizeImageUrl : function(fileInfo){
                    var url = this.getCdnUrl('D');
                    return url + fileInfo.imgViewUrl;
                },
                showEncodingVideoUrl : function(fileInfo){
                    var url = this.getCdnUrl('D');
                    return url + fileInfo.strmUrl;
                },
                loadVideo : function(fileSe,fileNm,storge,extsn,orgNm,setBasePath){
                    let url = "/common/loadMov.act?fileSe=" + fileSe + "&fileNm=" + fileNm + "&storge=" + storge + "&extsn=" + extsn + "&orgNm=" + orgNm;
                    if(typeof setBasePath != "undefined" && setBasePath != null){
                        if(setBasePath.trim() != ""){
                            url += "&setBasePath=" + setBasePath;
                        }
                    }

                    return url;
                },
                bindFileIconClass: function(extsn){
                    if (extsn == null || extsn == '') {
                        extsn = "etc";
                    }
                    var chkExtsn = extsn.toLowerCase();

                    if(chkExtsn != "bmp"&&chkExtsn != "jpg"&&chkExtsn != "gif"&&chkExtsn != "png"&&chkExtsn != "zip"&&
                        chkExtsn != "doc"&&chkExtsn != "hwp"&&chkExtsn != "ppt"&&chkExtsn != "xls"&&chkExtsn != "pdf" &&
                        chkExtsn != "docx"&&chkExtsn != "pptx"&&chkExtsn != "xlsx"){
                        chkExtsn = "etc";
                    }else{
                        if(chkExtsn == "xlsx"){
                            chkExtsn = "xls";
                        }else if(chkExtsn == "pptx"){
                            chkExtsn = "ppt";
                        }
                    }
                    return "__icon-" + chkExtsn;
                },
                searchCmmnCodeList:function(searchInfo){
                    const onbiLib = this;

                    return new Promise(function (resolve, reject) {
                        onbiLib.axios.post('/common/code/searchCmmnCodeList.act',{
                                searchInfo:searchInfo
                            }).then(function(response) {
                                resolve(response.data.codeList);
                            }.bind(this)).catch(function(e) {
                            reject(e);
                        });
                    });

                },
                searchSidoList:function(){
                    const onbiLib = this;

                    return new Promise(function (resolve, reject) {
                        onbiLib.axios.post('/common/code/searchSidoList.act',{})
                            .then(function(response) {
                                resolve(response.data.sidoList);
                            }.bind(this)).catch(function(e) {
                                reject(e);
                            });
                    });
                },
                searchSigunList:function(parcode){
                    const onbiLib = this;
                    
                    return new Promise(function (resolve, reject) {
                        onbiLib.axios.post('/common/code/searchSigunList.act',{
                                parcode:parcode
                            }).then(function(response) {
                                resolve(response.data.sigunList);
                            }.bind(this)).catch(function(e) {
                                reject(e);
                            });
                    });
                },
                setFileDownLoadUrl : function(url,params){
                    const hddnFrame = document.getElementById("hddnFrame");
                    hddnFrame.src = url + "?" + params;
                },
                setCdnFileDownLoadUrl : function(fileInfo,authKey){
                    const hddnFrame = document.getElementById("hddnFrame");
                    var url = this.$onbiLib.getCdnUrl('D');
                    hddnFrame.src = url +fileInfo.downUrl + '?authKey=' + authKey;
                },
                outLink: function(url){
                    window.open(url,"_blank");
                },
                getUrlParam : function(){
                    var _parammap = {};
                    document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
                        function decode(s) {
                            return decodeURIComponent(s.split("+").join(" "));
                        }

                        _parammap[decode(arguments[1])] = decode(arguments[2]);
                    });

                    return _parammap;
                },
                getUrlParam2 : function(url){
                    url = url.substring(url.indexOf('?'));
                    var _parammap = {};
                    url.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
                        function decode(s) {
                            return decodeURIComponent(s.split("+").join(" "));
                        }

                        _parammap[decode(arguments[1])] = decode(arguments[2]);
                    });

                    return _parammap;
                },
                onlyNumberPointKeydown : function(event){
                    event = event || window.event;
                    var keyID = (event.which) ? event.which : event.keyCode;
                    console.log(keyID);
                    if (!((keyID >= 48 && keyID <= 57) ||
                          (keyID >= 96 && keyID <= 105) ||
                          keyID == 8 ||
                          keyID == 46 ||
                          keyID == 37 ||
                          keyID == 39 ||
                          keyID == 110 ||
                          keyID == 9)){
                        event.preventDefault();
                    }
                },
                onlyNumberPointKeyup : function(event){
                    event = event || window.event;
                    var keyID = (event.which) ? event.which : event.keyCode;
                    if ( keyID == 8 || keyID == 46 || keyID == 37 || keyID == 39 || keyID == 9 )
                        return;
                    else
                        event.target.value = event.target.value.replace(/[^0-9^.]/g, "");
                },
                onlyNumberKeydown : function(event){
                    event = event || window.event;
                    var keyID = (event.which) ? event.which : event.keyCode;
                    if (!((keyID >= 48 && keyID <= 57) ||
                          (keyID >= 96 && keyID <= 105) ||
                          keyID == 8 ||
                          keyID == 46 ||
                          keyID == 37 ||
                          keyID == 39 ||
                          keyID == 9)){
                        event.preventDefault();
                    }
                },
                onlyNumberKeyup : function(event){
                    event = event || window.event;
                    var keyID = (event.which) ? event.which : event.keyCode;
                    if ( keyID == 8 || keyID == 46 || keyID == 37 || keyID == 39 || keyID == 9 )
                        return;
                    else
                        event.target.value = event.target.value.replace(/[^0-9]/g, "");
                },
                addComma: function(num) {
                    if(num != null&&typeof(num) != "undefined"&&num != ""){
                        const regexp = /\B(?=(\d{3})+(?!\d))/g;
                        return num.toString().replace(regexp, ',');
                    }else{
                        return 0;
                    }

                },
                searchCardBnkNm : function(code,cardCode){
                    let bnkNm = ' ';
                    const cardBnkInfo = this.cardBnkCdList.find(function(info){return info.code == code;});
                    if(typeof cardBnkInfo !='undefined'&&cardBnkInfo != null){
                        bnkNm = cardBnkInfo.cardNm
                    }

                    if(cardBnkInfo == 'undefined'||cardBnkInfo == null){
                        const cardInfo = this.cardCdList.find(function(info){return info.code == cardCode;});
                        if(typeof cardInfo !='undefined'&&cardInfo != null){
                            bnkNm = cardInfo.cardNm
                        }
                    }

                    return bnkNm
                },
                searchCardNm : function(code){
                    let cardNm = ' ';
                    const cardInfo = this.cardCdList.find(function(info){return info.code == code;});
                    if(typeof cardInfo !='undefined'&&cardInfo != null){
                        cardNm = cardInfo.cardNm
                    }
                    return cardNm
                },
                getFormatYmd (ymd, format) {
                    const yy = ymd.substring(0,4);
                    const mm = ymd.substring(4,6);
                    const dd = ymd.substring(6,8);

                    return yy + format + mm + format + dd;
                },
            },
            created:function(){
                var hostname = location.hostname;
                if(hostname.indexOf("localhost")>-1 || hostname.indexOf("192.168.")>-1){
                    this.hostnames.hwp = 'http://192.168.10.48:50004';
                    this.hostnames.acc = 'http://test.acc.bo6in.com';
                }
                else if(hostname.indexOf("test.bo6in.com")>-1 || hostname.indexOf("test.ma.bo6in.com")>-1 || hostname.indexOf("test.mb.bo6in.com")>-1){
                    this.hostnames.hwp = 'http://test.bo6in.com:54804';
                    this.hostnames.acc = 'http://test.acc.bo6in.com';
                }
                else {
                    this.hostnames.hwp = location.protocol + '//hwp.bo6in.com';
                    this.hostnames.acc = location.protocol + '//acc.bo6in.com';
                }
            },
            mounted: function(){

            }
        });
    }
};